module.exports = __webpack_public_path__ + "img/item3-1.8b09a34f.jpg";